import { Lang } from "Roblox";
import angular from "angular";

let login = angular
    .module("login", ["robloxApp", "roblox.formEvents", "modal", "captchaV2", "systemFeedback"])
    .config(["languageResourceProvider", function (languageResourceProvider) {
        languageResourceProvider.setLanguageKeysFromFile(Lang.LoginResources);
        languageResourceProvider.setLanguageKeysFromFile(Lang.CaptchaResources);
    }]);

export default login;